import { loadStripe } from '@stripe/stripe-js';

// Lazily create a single Stripe.js instance for the whole app. The publishable
// key is a build-time env var (safe to embed in the client bundle), mirroring
// how REACT_APP_SAM_DBAM_URL is provided. Returns null when unconfigured so the
// UI can show a clear "billing not configured" state instead of throwing.
let _promise;

export function getStripe() {
    if (_promise !== undefined) return _promise;
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    _promise = key ? loadStripe(key) : null;
    return _promise;
}
